import type { VkPost } from '../types'
import { loadVkOpenApi } from './loadVkOpenApi'

export async function renderVkPost(
  elementId: string,
  { owner_id, post_id, hash }: VkPost
) {
  await loadVkOpenApi()

  window.VK?.Widgets.Post(elementId, owner_id, post_id, hash)
}
